export var OFFICE_START_RESOURCE_FOLDER = 'officestartresources';
/**
 *
 * @param cdnDomain Found in office context
 * @param folder Folder name (e.g. officestartresources or officestartbundles)
 * @param fileName File name
 * @param fileExtension File extension
 * @returns full cdn url
 */
export function constructCdnUrl(cdnDomain, folder, fileName, fileExtension) {
    if (folder === void 0) { folder = OFFICE_START_RESOURCE_FOLDER; }
    if (!cdnDomain || !folder || !fileName || !fileExtension) {
        return undefined;
    }
    var scheme = cdnDomain && cdnDomain === 'localhost:3000' ? 'http' : 'https';
    return "".concat(scheme, "://").concat(cdnDomain, "/").concat(folder, "/").concat(fileName, ".").concat(fileExtension);
}
//# sourceMappingURL=constructCdnUrl.js.map